module.exports = __webpack_public_path__ + "img/92.82a0f2ac.jpg";